import { Injectable, inject } from '@angular/core';
import { VehicleMovementsService } from '../vehicle-movements.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  loadVehicleMovements,
  loadVehicleMovementsFailure,
  loadVehicleMovementsSuccess,
} from './vehicle-movements.actions';
import { of, switchMap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class VehicleMovementsEffects {
  private readonly actions$ = inject(Actions);
  private readonly vehicleMovementsService = inject(VehicleMovementsService);

  public readonly loadVehicleMovements$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadVehicleMovements),
      switchMap(({ vin }) =>
        this.vehicleMovementsService.getVehicleMovements(vin).pipe(
          map((vehicleMovements) =>
            loadVehicleMovementsSuccess({ vehicleMovements })
          ),
          catchError((error) => of(loadVehicleMovementsFailure({ error })))
        )
      )
    )
  );
}
